var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchpadChangeDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5.49288H0.9375C0.856251 5.49288 0.776607 5.51473 0.707493 5.55598C0.638378 5.59724 0.582524 5.65626 0.546188 5.72645C0.509853 5.79663 0.494471 5.8752 0.501768 5.95336C0.509065 6.03151 0.538751 6.10615 0.5875 6.16893L3.3 9.66198C3.3815 9.76693 3.48719 9.85211 3.60869 9.91078C3.73019 9.96946 3.86416 10 4 10C4.13584 10 4.26981 9.96946 4.39131 9.91078C4.51281 9.85211 4.6185 9.76693 4.7 9.66198L7.4125 6.16893C7.46125 6.10615 7.49094 6.03151 7.49823 5.95336C7.50553 5.8752 7.49015 5.79663 7.45381 5.72645C7.41748 5.65626 7.36162 5.59724 7.29251 5.55598C7.22339 5.51473 7.14375 5.49288 7.0625 5.49288H4.875V0H3.125V5.49288Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpadChangeDown);
export default __webpack_public_path__ + "static/media/launchpad-change-down.ee9369b07ee77edea08f9b084508b131.svg";
export { ForwardRef as ReactComponent };